import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _castArray from 'lodash/castArray';
import _first from 'lodash/first';
import _isEmpty from 'lodash/isEmpty';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import styles from './error.module.scss';
var Error = /*#__PURE__*/function (_PureComponent) {
  _inherits(Error, _PureComponent);
  var _super = _createSuper(Error);
  function Error() {
    _classCallCheck(this, Error);
    return _super.apply(this, arguments);
  }
  _createClass(Error, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        error = _this$props.error,
        label = _this$props.label,
        styleOverrides = _this$props.styleOverrides,
        errorClassName = _this$props.errorClassName,
        className = _this$props.className;
      var id = "".concat(label, "Error");
      if (_isEmpty(error)) return null;
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.error, " ").concat(errorClassName || className),
        id: id,
        style: styleOverrides
      }, _first(_castArray(error)));
    }
  }]);
  return Error;
}(PureComponent);
Error.propTypes = {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string,
  errorClassName: PropTypes.string,
  styleOverrides: PropTypes.object
};
Error.defaultProps = {
  error: '',
  errorClassName: '',
  className: '',
  styleOverrides: EMPTY_OBJECT
};
export default Error;